import Cover from "./Cover";
import Detail from "./Detail";
import Title from "./Title";

export default {
  Cover,
  Detail,
  Title
};
